import { DateTime } from 'luxon';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderWrapperComponent } from '@components/loader-wrapper/loader-wrapper.component';

import { LoaderState } from '@cxc/core/services';
import { NavigationService } from '@services/navigation.service';

@Component({
  selector: 'welcome-layout',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterModule, CommonModule, LoaderWrapperComponent],
})
export class WelcomeLayout {
  constructor(
    public locationService: NavigationService,
    loaderState: LoaderState
  ) {
    loaderState.borderRadius.set('var(--p-content-border-radius)');
  }

  currentYear = DateTime.now().year;
}
